export default __webpack_public_path__ + "static/media/h-w-3.2b97b4d9.svg";